/**
 * Central plan-limit checks (align with Limits tab / userUsage + tier caps).
 * Returns a block "reason" when usage is already at or over the plan cap for the attempted action.
 * @typedef {'emails'|'signed'|'templates'} UsageBlockReason
 */

/**
 * @param {object} o
 * @param {boolean} o.hasSubscription
 * @param {number} o.effectiveMaxEmails monthly cap (including top-ups in pool)
 * @param {number} o.emailsSentThisMonth
 * @param {number} o.emailsDelta additional sends this action would count (recipients or 1)
 * @param {number} o.effectiveMaxEmailsSigned
 * @param {number} o.currentEmailsSignedPerMonth
 * @param {number} o.templatesCount
 * @param {number} o.maxTemplates tier cap (0 = unlimited)
 * @param {'send'|'copyLink'|'newTemplate'} o.action
 * @returns {UsageBlockReason|null}
 */
export function getUsageBlockReason(o) {
  const {
    hasSubscription,
    effectiveMaxEmails = 0,
    emailsSentThisMonth = 0,
    emailsDelta = 1,
    effectiveMaxEmailsSigned = 0,
    currentEmailsSignedPerMonth = 0,
    templatesCount = 0,
    maxTemplates = 0,
    action,
  } = o

  if (action === 'newTemplate') {
    if (maxTemplates > 0 && templatesCount >= maxTemplates) {
      return 'templates'
    }
    return null
  }

  if (!hasSubscription) {
    return null
  }

  if (effectiveMaxEmailsSigned > 0 && currentEmailsSignedPerMonth >= effectiveMaxEmailsSigned) {
    return 'signed'
  }
  if (effectiveMaxEmails > 0 && emailsSentThisMonth + emailsDelta > effectiveMaxEmails) {
    return 'emails'
  }

  return null
}
